// src/hooks/useScoreboardUpdater.js
import { useCallback } from 'react';
import { useEventContext } from '../context/EventContext';

export function useScoreboardUpdater() {
  const { boardConfigs, refreshTablero } = useEventContext();

  // Construye y lanza un CONFIG_UPDATE para “seleccionar” un atleta (modo espera)
  const selectAthlete = useCallback((heatDetails, athlete, attempt) => {
    const heatKey = `${heatDetails.eventNumber}_${heatDetails.round}_${heatDetails.heat}`;
    const assigned = boardConfigs.filter(c => c.settings?.assignedHeat === heatKey);
    assigned.forEach(cfg => {
      const e = {
        eventName: heatDetails.eventName,
        eventSubtitle: heatDetails.eventSubtitle || '',
        eventNumber: heatDetails.eventNumber,
        round: heatDetails.round,
        heat: heatDetails.heat,
        participants: [ { ...athlete, isActive: true, activeAttempt: attempt } ],
        activeAthlete: { ...athlete, isActive: true, activeAttempt: attempt },
        displayMode: 'individual'
      };
      refreshTablero(cfg.id, {
        ...cfg,
        settings: { ...cfg.settings, displayRows: 1 },
        eventData: e
      });
    });
  }, [boardConfigs, refreshTablero]);

  // Construye y lanza un CONFIG_UPDATE para “guardar” un resultado
  const saveResult = useCallback((heatDetails, athlete, attempt) => {
    const heatKey = `${heatDetails.eventNumber}_${heatDetails.round}_${heatDetails.heat}`;
    const assigned = boardConfigs.filter(c => c.settings?.assignedHeat === heatKey);
    assigned.forEach(cfg => {
      const e = {
        eventName: heatDetails.eventName,
        eventSubtitle: heatDetails.eventSubtitle || '',
        eventNumber: heatDetails.eventNumber,
        round: heatDetails.round,
        heat: heatDetails.heat,
        participants: [ athlete ],
        activeAthlete: athlete,
        displayMode: 'individual'
      };
      refreshTablero(cfg.id, {
        ...cfg,
        settings: { ...cfg.settings, displayRows: 1 },
        eventData: e
      });
    });
  }, [boardConfigs, refreshTablero]);

  // Construye y lanza un CONFIG_UPDATE para limpiar todo (volver a inicial)
  const clear = useCallback((heatDetails) => {
    const heatKey = `${heatDetails.eventNumber}_${heatDetails.round}_${heatDetails.heat}`;
    const assigned = boardConfigs.filter(c => c.settings?.assignedHeat === heatKey);
    assigned.forEach(cfg => {
      const e = {
        eventName: heatDetails.eventName,
        eventSubtitle: heatDetails.eventSubtitle || '',
        eventNumber: heatDetails.eventNumber,
        round: heatDetails.round,
        heat: heatDetails.heat,
        participants: [],
        activeAthlete: null,
        displayMode: 'initial'
      };
      refreshTablero(cfg.id, {
        ...cfg,
        settings: { ...cfg.settings, displayRows: 1 },
        eventData: e
      });
    });
  }, [boardConfigs, refreshTablero]);

  return { selectAthlete, saveResult, clear };
}
